import { Role } from '@/Enums/Users/Role.enum';
import { IControlOption } from '@/Interfaces/ControlOption.interface';
import PhoneNumberInput from '@/components/PhoneNumberInput';
import { getAllowedUserRoleOptions } from '@/helpers/roles';
import { EMAIL_RULES, FIRST_NAME_RULES, LAST_NAME_RULES, PHONE_NUMBER_RULES } from '@/utils/validationRules';
import { InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import UserTypeIcon from '../../Components/UserTypeIcon';

interface IProps {
  meRole: Role;
  disableRoleControl?: boolean;
}

const UserInfo = ({ meRole, disableRoleControl }: IProps) => {
  const { control } = useFormContext();

  return (
    <>
      <div>
        <InputLabel id='user-type-select-label'>User Type</InputLabel>
        <Controller
          name='userRole'
          control={control}
          render={({ field }) => (
            <Select
              {...field}
              disabled={disableRoleControl}
              labelId='user-type-select-label'
              id='user-type-select'
              fullWidth
            >
              {(getAllowedUserRoleOptions(meRole) as IControlOption[]).map((option, i) => (
                <MenuItem key={i} value={option.value}>
                  <div className='flex'>
                    <UserTypeIcon userRole={option.value} className='w-[20px] text-[#84818A] mr-[10px]' />
                    <span>{option.label}</span>
                  </div>
                </MenuItem>
              ))}
            </Select>
          )}
        />
      </div>
      <div className='mt-4 flex gap-[15px]'>
        <div className='flex-1'>
          <InputLabel htmlFor='first-name'>
            First Name<span className='text-[#fe4033]'>*</span>
          </InputLabel>
          <Controller
            name='firstName'
            control={control}
            rules={FIRST_NAME_RULES}
            render={({ field, fieldState }) => (
              <TextField
                {...field}
                fullWidth
                error={!!fieldState.error}
                helperText={fieldState.error?.message}
                placeholder='Enter First Name'
                id='first-name'
              />
            )}
          />
        </div>
        <div className='flex-1'>
          <InputLabel htmlFor='last-name'>
            Last Name<span className='text-[#fe4033]'>*</span>
          </InputLabel>
          <Controller
            name='lastName'
            control={control}
            rules={LAST_NAME_RULES}
            render={({ field, fieldState }) => (
              <TextField
                {...field}
                fullWidth
                error={!!fieldState.error}
                helperText={fieldState.error?.message}
                placeholder='Enter Last Name'
                id='last-name'
              />
            )}
          />
        </div>
      </div>
      <div className='flex gap-[15px] mt-4'>
        <div className='flex-1'>
          <InputLabel id='email-label' htmlFor='email'>
            Email<span className='text-[#fe4033]'>*</span>
          </InputLabel>
          <Controller
            name='email'
            control={control}
            rules={EMAIL_RULES}
            render={({ field, fieldState }) => (
              <TextField
                {...field}
                placeholder='example@example.com'
                id='email'
                error={!!fieldState.error}
                helperText={fieldState.error?.message}
                fullWidth
              />
            )}
          />
        </div>
        <div className='flex-1'>
          <InputLabel htmlFor='phone-number'>Phone Number</InputLabel>
          <Controller
            name='phone'
            control={control}
            rules={PHONE_NUMBER_RULES}
            render={({ field, fieldState }) => (
              <PhoneNumberInput
                {...field}
                //@ts-expect-error js component props
                helperText={fieldState.error?.message}
                fullWidth
                error={!!fieldState.error}
              />
            )}
          />
        </div>
      </div>
    </>
  );
};

export default UserInfo;
